import React from 'react';

import Select from 'components/Select';

import { ISupplierSelectProps } from './interface';
import { IOption } from 'components/Select/interface';

export const SupplierSelect: React.FC<ISupplierSelectProps> = (props: ISupplierSelectProps) => {
    const handledProps = {
        ...props,
        stateName: props.stateName || "supplierId",
        name: props.name || "Fornecedor",
        id: props.id || "SUPPLIER",
        skipSelectOption: props.skipSelectOption || true,
        customClassName: props.customClassName || 'w-30',
        options: props.options || getOptions(),
    }

    function getOptions() {
        const options: Array<IOption> = new Array<IOption>({
            value: '',
            label: 'SELECIONE'
        });

        const list = props.list.toSorted((a, b) => a.name.localeCompare(b.name));
        Object.keys(list).forEach((key: any) => {
            options.push({
                value: list[key].id,
                label: list[key].name,
            });
        });

        return options;
    }

    return (<Select
        {...handledProps}
    />);
};